export default __webpack_public_path__ + "static/groenhout_g-636770ee597b3e5cec9b6674192ab227.png";